import { Link } from "@/atoms"
import { NAMES_ROUTES } from "@/const/routes.constants"
import { WORKLOAD_STATUS } from "@/domain/application"
import { useTranslation } from "@/hooks/useTranslation"
import { ExternalLinkIcon } from "@/molecules/ExternalLinkIcon"

import styles from "./ImpactCell.module.scss"

import type { ExternalLinkProps } from "."

export const ImpactExternalLink = (props: ExternalLinkProps) => {
  const { t } = useTranslation()
  const { record, children, tKey = "triage.drawer.impact.allApps" } = props
  const commonParams = {
    workloadStatus: `${WORKLOAD_STATUS.ACTIVE},${WORKLOAD_STATUS.INACTIVE}`
  }
  const params = new URLSearchParams(
    "riskId" in record
      ? {
          projectName: record.projectName,
          riskId: record.riskId,
          ...commonParams
        }
      : { projectName: record.name, ...commonParams }
  )
  const externalLink = `/${NAMES_ROUTES.DISCOVERY.ROOT}/${NAMES_ROUTES.DISCOVERY.APPLICATIONS}?${params.toString()}`

  if (children)
    return (
      <Link href={externalLink} target="_blank" className={styles.externalLink}>
        {children}
      </Link>
    )

  return (
    <ExternalLinkIcon
      wrap
      className={styles.externalLink}
      iconPlacement="start"
      text={t(tKey)}
      href={externalLink}
    />
  )
}
